const visileColumns = [
  
  {
    title: "Id",
    field: "Id",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },
  // {
  //   title: "Subscriber Id",
  //   field: "SubscriberID",
  //   locked: false,
  //   filter: "text",
  //   width: 200,
  //   show: true,
  // },
  {
    title: "Description",
    field: "Description",
    locked: false,
    filter: "text",
    width: 500,
    show: true,
  },
  
  {
    title: "CreatedDate",
    field: "CreatedDate",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 200,
    show: true,
  },
  
];

export default visileColumns;
